import axios from "axios";

import { apiConfig } from "../config/authConfig";

import { IExpense, IExpenseEntityAssignmentRequest } from "../types/expense";

import { CredentialManager } from "../classes/credentialManager";



export namespace ExpenseService {
	const credentialManager = CredentialManager.getInstance();

	/**********
	 * Convert one api response object to one Expense.
	 * @param data Expense response data from an API.
	 **********/
	export function mapExpense(data: any) {
		let item: IExpense = {
			id: data.id,
			name: data.name,
			category: data.category,
			isActive: data.isActive,
			spreadAcrossMaterials: data.spreadAcrossMaterials,
			process: data.process,
			assignedEntities: data.assignedEntities
		}

		return item;
	}

	/**********
	 * Convert an array of api response objects to an array of Expenses.
	 * @param data Expense data from an API response.
	 **********/
	export function mapExpenses(data: any) {
		let items: IExpense[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any) => {
				items.push(mapExpense(item));
			})
		}

		return items;
	}

	/**********
	 * Gets all expenses.
	 **********/
	export async function getExpenses() {
		const employeeResponse = axios.get(
			apiConfig.default + "/expensetype/all/includeInactive",
			{
				headers: {
					'Authorization': `Bearer ${await credentialManager.getAccessToken()}`
				},
			}
		)

		return employeeResponse;
	}

	/**********
	 * Gets an expense by id.
	 * @param id The id of the expense.
	 **********/
	export async function getExpense(id: string) {
		const employeeResponse = axios.get(
			apiConfig.default + "/expensetype/" + id,
			{
				headers: {
					'Authorization': `Bearer ${await credentialManager.getAccessToken()}`
				},
			}
		)

		return employeeResponse;
	}

	/**********
	 * Adds an expense.
	 * @param payload The expense object to add.
	 **********/
	export async function addExpense(payload: IExpense) {

		const employeeResponse = axios.post(
			apiConfig.default + "/expensetype",
			payload,
			{
				headers: {
					'Authorization': `Bearer ${await credentialManager.getAccessToken()}`,
					'Content-Type': 'application/json'
				},
			}
		)

		return employeeResponse;
	}

	/**********
	 * Updates an expense.
	 * @param payload The updated expense object.
	 **********/
	export async function updateExpense(payload: IExpense) {

		const employeeResponse = axios.put(
			apiConfig.default + "/expensetype",
			payload,
			{
				headers: {
					'Authorization': `Bearer ${await credentialManager.getAccessToken()}`,
					'Content-Type': 'application/json'
				},
			}
		)

		return employeeResponse;
	}

	/**********
	 * Deactivates an expense by id.
	 * @param id The id of the expense.
	 **********/
	export async function deactivateExpense(id: string) {
		const employeeResponse = axios.put(
			apiConfig.default + "/expensetype/" + id + "/deactivate",
			"payload placeholder",
			{
				headers: {
					'Authorization': `Bearer ${await credentialManager.getAccessToken()}`
				},
			}
		)

		return employeeResponse;
	}

	/**********
	 * Updates assignments of entities that are allowed to claim a given expense.
	 * @param request The assignment request containing the expense ID, entity type, and the selected entity IDs.
	 **********/
	export async function setAssignedEntities(request: IExpenseEntityAssignmentRequest) {
		const apiResponse = axios.put(
			apiConfig.default + "/expensetype/assignment",
			request,
			{
				headers: {
					'Authorization': `Bearer ${await credentialManager.getAccessToken()}`
				},
			}
		)

		return apiResponse;
	}
}
